// extracted by mini-css-extract-plugin
export var ConsultContainer = "index-module--ConsultContainer--Npw8u";
export var ConsultContent = "index-module--ConsultContent--tu9f-";
export var listBorder = "index-module--listBorder--aYxe8";
export var listContent = "index-module--listContent--OQrw-";